import { Chip, Grid } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const FeatureFlagBadge = ({ title, activeSetting }) => {
  return (
    <Grid
      gap='.25em'
      alignItems='center'
      wrap='nowrap'
      className='feature-flag'
      justifyContent='space-between'
      container
      key={`sms-automation-${title}`}
    >
      <Grid
        item
        sx={(theme) => ({
          color: activeSetting ? 'black' : theme.palette.primary.main,
        })}
      >
        {title}
      </Grid>
      <Grid item sx={{ flexBasis: '70px', textAlign: 'end' }}>
        <Chip
          className='feature-flag-badge'
          label={activeSetting ? 'Active' : 'Inactive'}
          sx={(theme) => ({
            background: activeSetting ? theme.palette.success.light : '#7c7c7c',
          })}
          size='small'
        />
      </Grid>
    </Grid>
  );
};


FeatureFlagBadge.propTypes = {
  title: PropTypes.string,
  activeSetting: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool
  ])
}

export default FeatureFlagBadge;
